/**
 * A blueprint payload is "empty" when none of its three graphs carry a single
 * node. Such a row carries no information — it is what the Sync-to-Cloud flow
 * used to fabricate when localStorage had nothing for the character, and what
 * loadBlueprintFromDB must treat as "no blueprint" rather than hydrate.
 *
 * The distinction matters because hydrating an all-empty blueprint CLOBBERS
 * whatever the graph refs already hold (e.g. a ?blueprint= URL load) with
 * nothing: state machines never enter their initial state and the avatar
 * freezes in bind pose. That is exactly the 2026-07-01 main-CI regression —
 * an accidental empty myra blueprint row on staging out-raced and wiped the
 * URL-loaded conversational graph on every test boot.
 */
export function isEmptyBlueprintData(data) {
  if (!data || typeof data !== 'object') return true
  const bodyNodes = data.body?.nodes?.length ?? 0
  const faceNodes = data.face?.nodes?.length ?? 0
  const eventNodes = data.events?.eventNodes?.length ?? 0
  return bodyNodes === 0 && faceNodes === 0 && eventNodes === 0
}
